import axios from "axios";
import { Base_URL } from "../url";

/**
 * =========================
 * HOLIDAY MASTER ORG APIs
 * =========================
 */

/**
 * Create Holiday
 */
export const createHoliday = async (payload, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/HolidayMasterOrg/CreateHoliday`,
      payload,
      {
        params: { UserName: userName },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating holiday:", error);
    throw error;
  }
};

/**
 * Get Holidays by OrgId
 */
export const getHolidaysByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/HolidayMasterOrg/GetHolidaysByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching holidays for OrgId ${orgId}:`, error);
    throw error;
  }
};

/**
 * Get Holiday by HolidayId
 */
export const getHolidayById = async (holidayId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/HolidayMasterOrg/GetHolidayById/${holidayId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching holiday ${holidayId}:`, error);
    throw error;
  }
};

/**
 * Update Holiday by HolidayId
 */
export const updateHoliday = async (payload, userName) => {
  try {
    const response = await axios.put(
      `${Base_URL}/HolidayMasterOrg/UpdateHoliday`,
      payload,
      {
        params: { UserName: userName },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error updating holiday with ID ${payload?.holidayId}:`,
      error,
    );
    throw error;
  }
};
